import { Col, Form, Input, Row } from "antd";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../apis/store";
import Selects from "../../../../biblio/Selects/Selects";
import Inputs from "../../../../biblio/Inputs/Inputs";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import {
  addScolarshipSchool,
  getAllSchoolScholarship,
} from "../../../../apis/actions/scholarship.actions";
import { showNotitfication } from "../../../../components/utils/utils";
import ModalComponent from "../../../../biblio/Modal/ModalComponent";
import { useState } from "react";
import { setResModel, setResIds } from "../../../../apis/slices/ratingSlice";

const { TextArea } = Input;

interface AddRegistrationRequestProps {
  beneficiary: any;
  setIsModalVisible: (v: boolean) => void;
  isModalVisible: boolean;
}

const AddRegistrationSchoolRequest = ({
  beneficiary,
  setIsModalVisible,
  isModalVisible,
}: AddRegistrationRequestProps) => {
  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    form.resetFields();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalVisible]);
  const onFinish = async () => {
    try {
      await form.validateFields();
      setIsSubmitting(true);

      const FormValues = form.getFieldsValue();

      const requestsFormData = {
        ...FormValues,
        partner_id: form.getFieldValue("partner_id").value,
      };

      dispatch(addScolarshipSchool(requestsFormData)).then((result: any) => {
        const request = result?.payload?.result;
        if (request?.code === 200) {
          dispatch(setResModel(request?.res_model));
          dispatch(setResIds([request?.scholarship_application_id]));
          showNotitfication(request?.message, "success", dispatch);
          form.resetFields();
          setIsModalVisible(false);
          dispatch(getAllSchoolScholarship({ limit: 8, page: 1 }));
        } else {
          showNotitfication(result?.payload?.error?.data?.message, "error");
          setIsModalVisible(false);
        }
        setIsSubmitting(false);
      });
    } catch (error) {
      console.log(error, "error");
      setIsSubmitting(false);
    }
  };

  return (
    <ModalComponent
      title=""
      open={isModalVisible}
      onClose={() => setIsModalVisible(false)}
      closeOnOutsideClick={true}
      width={800}
      modalStyle={{ top: 200 }}
    >
      <Row justify={"center"}>
        <p className="takaful--confirm-logout">إنشاء طلب منحة المدرسية</p>
      </Row>
      <Form
        dir="rtl"
        form={form}
        layout="vertical"
        style={{ paddingTop: "1.5rem" }}
      >
        <Row gutter={16}>
          <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="partner_id"
              label="المستفيد"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <Selects
                options={beneficiary}
                className="takaful--request-select"
              />
            </Form.Item>
          </Col>
          <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="rate"
              label="معدل"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <Inputs
                className="takaful--request-input-number"
                controls={false}
                type="tel"
              />
            </Form.Item>
          </Col>
          <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="school_name"
              label="اسم المدرسة"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
          <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="request_number"
              label="رقم الطلب"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
          <Col xxl={16} xl={16} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="application_reason"
              label="سبب التقديم"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <TextArea
                className="takaful--suggestions-complaints-textarea"
                rows={3}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row justify={"end"} dir="rtl" style={{ width: "100%" }}>
          <Col xxl={4} xl={4} lg={4} md={4} sm={9} xs={9}>
            <PrimaryButton
              loading={isSubmitting}
              disabled={isSubmitting}
              style={{ width: "100%" }}
              onClick={() => {
                onFinish();
              }}
              title="إرسال"
            />
          </Col>
        </Row>
      </Form>
    </ModalComponent>
  );
};

export default AddRegistrationSchoolRequest;
